import { stockInStockWasEntered } from './stockOnHand'
import { hasPendingStockTakeParEdits } from './stockTakeLinePar'

const qty = value => {
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

const asLineId = line => String(line?._id || line?.lineId || '').trim()

/** Count fields that make Save / live OTP preview diverge from the last persist. */
export const stockTakeLineDiffersFromSaved = (saved, draft) => {
  if (!draft) return false
  if (!saved) return true
  return (
    qty(saved.inStock) !== qty(draft.inStock) ||
    stockInStockWasEntered(saved) !== stockInStockWasEntered(draft) ||
    qty(saved.wastage) !== qty(draft.wastage) ||
    qty(saved.sold) !== qty(draft.sold)
  )
}

export const stockTakeDraftIsDirty = ({
  draftLines = [],
  savedLines = [],
  addedCount = 0,
  parEdits,
  venueProducts,
  plan,
  venueId,
} = {}) => {
  if (Number(addedCount) > 0) return true
  if (
    hasPendingStockTakeParEdits({
      parEdits,
      venueProducts,
      plan,
      venueId,
    })
  ) {
    return true
  }
  const savedById = new Map()
  ;(Array.isArray(savedLines) ? savedLines : []).forEach(line => {
    const id = asLineId(line)
    if (id) savedById.set(id, line)
  })
  return (Array.isArray(draftLines) ? draftLines : []).some(draft => {
    const id = asLineId(draft)
    if (!id) return false
    const saved = savedById.get(id)
    if (!saved) return false
    return stockTakeLineDiffersFromSaved(saved, draft)
  })
}
